import { Status } from "./Status";

export default Status;
